export default "__VITE_ASSET__CFo4$UpL__"